export default "__VITE_ASSET__CDT8s8YC__"